import React, { useEffect, useState } from 'react';
import { fetchHardCrabCosts } from '../services/api';

/**
 * Reports > Hard Crab Costs: hard crab cost by order and product for a ship date range, the
 * admin portal report on the SQL01 copy (Azure exit WS8).
 */

const iso = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
const daysAgo = (n) => { const d = new Date(); d.setDate(d.getDate() - n); return iso(d); };

export default function HardCrabCosts({ navigateTo }) {
  const [from, setFrom] = useState(daysAgo(7));
  const [to, setTo] = useState(daysAgo(0));
  const [rows, setRows] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    let live = true;
    setRows(null);
    setError(null);
    fetchHardCrabCosts(from, to)
      .then((r) => { if (live) setRows(r); })
      .catch((e) => { if (live) setError(e.message); });
    return () => { live = false; };
  }, [from, to]);

  return (
    <div>
      <div className="page-header">
        <h2 style={{ fontSize: 16, fontWeight: 700, color: 'var(--navy)', margin: 0 }}>Hard Crab Costs</h2>
      </div>
      <div className="port-filters">
        <input type="date" className="form-input" style={{ width: 'auto' }} value={from} onChange={(e) => setFrom(e.target.value)} />
        <input type="date" className="form-input" style={{ width: 'auto' }} value={to} onChange={(e) => setTo(e.target.value)} />
      </div>
      <div className="card">
        <div className="card-header">Lines{rows ? ` (${rows.length})` : ''}</div>
        {error && <div style={{ padding: 16, fontSize: 12, color: 'var(--red)' }}>Error: {error}</div>}
        {!rows && !error && <div style={{ padding: 16, fontSize: 12, color: 'var(--gray-500)' }}>Loading...</div>}
        {rows && rows.length === 0 && <div style={{ padding: 16, fontSize: 12, color: 'var(--gray-500)' }}>No hard crab lines in this range.</div>}
        {rows && rows.length > 0 && (
          <div className="port-scroll">
            <table className="trans-table">
              <thead>
                <tr><th>Order</th><th>Product</th><th>Cost</th></tr>
              </thead>
              <tbody>
                {rows.map((r, i) => (
                  <tr key={`${r.orderId}-${i}`} style={{ cursor: 'pointer' }} onClick={() => navigateTo('order-details', r.bcOrderId || r.orderId)}>
                    <td style={{ color: 'var(--orange)', fontWeight: 600 }}>{r.bcOrderId || r.orderId}</td>
                    <td>{r.product}</td>
                    <td>${Number(r.cost || 0).toFixed(2)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}